var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.giveawayViewToggle)?_c('wx-btn-icon',{staticClass:"activator-btn",attrs:{"wxid":_vm.$options.name,"title":_vm.$t('tiles.selectorMenu.btnHint'),"x-small":_vm.isMobile,"small":!_vm.isMobile,"text":""},on:{"click":_vm.openMenu}},[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }